// tempIdGenerator.js
// Generate temporary IDs for new items before they are assigned database IDs

/**
 * Generate a temporary event ID
 * Used when creating new events in the UI before they're saved to the database
 */
export const generateTempEventId = () => {
  return `temp_event_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

/**
 * Generate a temporary scenario ID
 * Used when creating new scenarios in the UI before they're saved to the database
 */
export const generateTempScenarioId = () => {
  return `temp_scenario_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

/**
 * Generate a temporary attribute ID
 * Used when creating new attributes in the UI before they're saved to the database
 */
export const generateTempAttributeId = () => {
  return `temp_attr_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};
